<h2>Tell us about what is it about</h2>
<form [formGroup]="stepFormGroup">
  <shared-form-field-wrapper
    class="span-2"
    label="Name this enquiry for future reference"
    [formControl]="stepFormGroup.controls.helpCaseName"
    name="smart-search-name">
    <shared-input-text
      name="smart-search-name"
      [formControl]="stepFormGroup.controls.helpCaseName" />
  </shared-form-field-wrapper>
  <shared-form-field-wrapper
    class="span-2"
    label="What is the subject?"
    [formControl]="stepFormGroup.controls.type">
    <shared-select
      placeholder="Select enquiry type"
      [formControl]="stepFormGroup.controls.type"
      [options]="helpCaseTypeSelectItems"
      [showLogo]="false" />
  </shared-form-field-wrapper>
  <shared-form-field-wrapper
    class="span-2"
    label="Your enquiry"
    [formControl]="stepFormGroup.controls.description"
    name="your-enquiry">
    <shared-input-text-area
      name="your-enquiry"
      [rows]="3"
      [formControl]="stepFormGroup.controls.description" />
  </shared-form-field-wrapper>
  <shared-form-field-wrapper
    class="span-2"
    label="Phone number"
    name="tel"
    [formControl]="stepFormGroup.controls.phoneNumber">
    <shared-input-text name="tel" [formControl]="stepFormGroup.controls.phoneNumber" />
  </shared-form-field-wrapper>
</form>
<cp-stepper
  class="stepper"
  [forwardButtonEnabled]="stepFormGroup.valid"
  [hideProgressBar]="true"
  [showForwardButtonIcon]="false"
  forwardButtonLabel="Request a callback"
  [hideBackButton]="!isBackButtonVisible"
  [showSkipButton]="false"
  [loading]="isSaving"
  (forward)="emitNextClicked()"
  (back)="emitBackClicked()" />
